import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Title', prop: 'title' },
  { title: 'Program', prop: 'program_id', references: 'admin/programs', referenceProp: 'name' },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' },
  { title: 'Update', prop: 'updated_at', format: 'dateWithDay' },
  { title: 'Restricted access', prop: 'has_restricted_access', format: 'bool' }
]

const filters = [
  { name: 'Filter by title', prop: 'filters.title_ilike', type: 'text', enabled: true },
  { name: 'Show only restricted pages', prop: 'filters.has_restricted_access', type: 'bool', value: true, enabled: false },
  { name: 'Show deleted', prop: 'with_deleted', type: 'bool', value: true, enabled: false }
]

const defaults = {
  order: [{ column: 'title', direction: 'asc' }]
}

const Pages = props => (
  <List
    title='Pages'
    apiPath='admin/pages'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Pages
